import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, watch } from 'vue'
    import { useRoute } from '@common/composables'
    import { useDashboardPage } from '@Organizations/Users/Domain/pages-core'
    import Navigation from '@common/Navigation.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardPage',
  setup(__props) {

    const { useUserDashboardQuery } = useDashboardPage()
    const { modelUserDashboardQueryV1, runUserDashboardQueryV1, authorized, completed } = useUserDashboardQuery()
    const categories = computed(() => modelUserDashboardQueryV1.value?.Categories || [])
    const logoUrl = computed(() => modelUserDashboardQueryV1.value?.LogoUrl)

    document.title = "TransparentChoice Dashboard"

    onMounted(() => runUserDashboardQueryV1())

    watch(authorized, () => {
        if (authorized.value === false) {
            location.href = '/#/signin';
        }
    })

return { __sfc: true,useUserDashboardQuery, modelUserDashboardQueryV1, runUserDashboardQueryV1, authorized, completed, categories, logoUrl, Navigation }
}

})